
// トップページ H2見出し英語
$('#shopify-section-template--19854432567548__featured_collection h2').before('<div class="scTtlEng">products</div>');
$('#shopify-section-template--19854432567548__featured_collection_yqX8Vd h2').before('<div class="scTtlEng">ranking</div>');
$('#shopify-section-template--19854432567548__multicolumn_EtA3Jh h2').before('<div class="scTtlEng">special feature</div>');
$('.section-template--19854432567548__featured_blog_R3ABKj-padding h2').before('<div class="scTtlEng">column</div>');
$('.section-template--19854432567548__featured_blog_EpUcNH-padding h2').before('<div class="scTtlEng">News</div>');
$('.section-template--19854432567548__featured_blog_DUMtVd-padding h2').before('<div class="scTtlEng">FAQ</div>');

// ヘッダー トグルボタン
$('.hdToggle').on('click', function() {
    if($('.section-header').hasClass('drwOpen')){
        $('.section-header').removeClass('drwOpen');
    } else {
        $('.section-header').addClass('drwOpen');
    }
});




// ページ先頭に戻るボタン
const pagetop_btn = document.querySelector(".btnPageTop");

// .pagetopをクリックしたら
pagetop_btn.addEventListener("click", scroll_top);

// ページ上部へスムーズに移動
function scroll_top() {
  window.scroll({ top: 0, behavior: "smooth" });
}

// スクロールされたら表示
window.addEventListener("scroll", scroll_event);
function scroll_event() {
  if (window.pageYOffset > 100) {
    pagetop_btn.style.opacity = "1";
  } else if (window.pageYOffset < 100) {
    pagetop_btn.style.opacity = "0";
  }
}


